(function ($) {
    "use strict";

    $(function () {

        if (window.getComputedStyle(document.documentElement).scrollBehavior !== 'smooth') {
            const links = document.querySelectorAll('a[href^="#"]');
            links.forEach((link) => {
                const target = document.querySelector(link.getAttribute('href'));
                if (target) {
                    link.addEventListener('click', (event) => {
                        event.preventDefault();
                        target.scrollIntoView({ behavior: 'smooth' });
                    });
                }
            });
        }

        if ($(".js-section-menu").length) {
            const spyNav = document.querySelector(".js-section-menu");
            const articles = [...document.querySelectorAll(".js-section-ids")];

            const spyItem = (entries, observer) => {
                entries.forEach((entry) => {
                    const { id } = entry.target;
                    const spy = spyNav.querySelector(`.js-section-menu-item[href="#${id}"`);

                    if (spy != null) {
                        spy.classList.remove("active");
                        if (!entry.isIntersecting) return;
                        spy.classList.add("active");
                    }
                });
            };

            const observer = new IntersectionObserver(spyItem, {
                rootMargin: "0.5% 0% -95% 0%",
            });

            articles.forEach((article) => observer.observe(article));

            const residentialMenu = document.querySelector(".js-section-menu");

            const handler = (entries) => {
                if (!entries[0].isIntersecting) {
                    residentialMenu.classList.remove("active");
                    $(".js-scroll-up").slideUp();
                } else {
                    residentialMenu.classList.add("active");
                    $(".js-scroll-up").slideDown();
                }
            };

            // create the observer
            const residentialMenuObserver = new IntersectionObserver(handler, { rootMargin: "0.5% 0% -95% 0%" });
            // give the observer some dom nodes to keep an eye on
            residentialMenuObserver.observe(residentialMenu);
        }

        $(".js-section-ids")
            .filter(function () {
                return $(this).css("margin-top") !== "0px";
            })
            .addClass("scroll__to--mod");
    });
})(jQuery);
